import { Table } from '@dixa/lib-shared-habla';

import { CustomForm } from '../../../../customForms.types';

import { EmptyRow } from './components/emptyRow';
import { FormTableRow } from './components/formTableRow';
import { LoadingRow } from './components/loadingRow';

type Props = {
  /** List of forms to be displayed */
  forms: CustomForm[];
  /** Whether forms are loading */
  isLoading?: boolean;
  /** Callback to be called when the user clicks on the edit button */
  onEdit: (form: CustomForm) => void;
  /** Callback to be called when the user clicks on the rename button */
  onRename: (form: CustomForm) => void;
  /** Callback to be called when the user clicks on the duplicate button */
  onDuplicate: (form: CustomForm) => void;
  /** Callback to be called when the user clicks on the delete button */
  onDelete: (form: CustomForm) => void;
};

/** Renders a table containing the list of all forms */
export function CustomFormsTable({
  forms,
  isLoading,
  onEdit,
  onRename,
  onDuplicate,
  onDelete,
}: Props): JSX.Element {
  const hasAnyFormUsedInAnyFlows =
    forms.some((form) => form.usage.length > 0) ?? false;

  const noForms = forms.length === 0;

  return (
    <Table
      stickyHeader
      stickyFooter
      expandableRowsProps={{ expandableRows: hasAnyFormUsedInAnyFlows }}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th width="70%">Name</Table.Th>
          <Table.Th width="20%">Used in</Table.Th>
          <Table.Th width="10%" />
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {noForms && isLoading && <LoadingRow />}
        {noForms && isLoading === false && <EmptyRow />}
        {forms.map((form) => (
          <FormTableRow
            key={form.id}
            form={form}
            onEdit={() => onEdit(form)}
            onRename={() => onRename(form)}
            onDuplicate={() => onDuplicate(form)}
            onDelete={() => onDelete(form)}
          />
        ))}
      </Table.Tbody>
    </Table>
  );
}
